export default __webpack_public_path__ + "static/media/aziza.2c63f27f.jpg";